<template>
  <input v-model="inputVal" @input="validateInput" :class="extraStyle" />
</template>
<script setup>
import { ref, watchEffect } from "vue";
import { useNumericInput, useDecimalInput } from "@/constants/formValidator.js";
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: "",
  },
  extraStyle: {
    type: Object,
    default: () => {},
  },
  charLimit: {
    type: Number,
    default: null,
  },
  maxLength: {
    type: Number,
    required: false,
  },
  minLength: {
    type: Number,
    required: false,
  },
  allowDecimal: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "start-watching"]);
const inputVal = ref("");

const formatDisplay = (raw) => {
  if (raw === null || raw === undefined || raw === "") return "";
  const parts = raw.toString().split(".");
  parts[0] = Number(parts[0]).toLocaleString("en-US");
  return parts.join(".");
};

function validateInput() {
  const rawValue = props.allowDecimal
    ? useDecimalInput(inputVal.value, props.minLength, props.maxLength)
    : useNumericInput(
        inputVal.value,
        props.minLength,
        props.maxLength,
        props.charLimit
      );

  inputVal.value = formatDisplay(rawValue);

  const numericValue = rawValue === "" ? "" : parseFloat(rawValue);
  emit("update:modelValue", numericValue);
  emit("start-watching");
}

watchEffect(() => {
  let val = props.modelValue;
  if (val === "" || val === null || val === undefined) {
    inputVal.value = "";
    return;
  }

  let numericVal = parseFloat(val);

  if (props.maxLength !== undefined && numericVal > props.maxLength)
    numericVal = props.maxLength;
  if (props.minLength !== undefined && numericVal < props.minLength)
    numericVal = props.minLength;

  if (numericVal !== val) {
    emit("update:modelValue", numericVal);
  }

  inputVal.value = formatDisplay(numericVal);
});
</script>
